import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20with%20deep%20crimson%20and%20dark%20amber%20flowing%20waves%2C%20luxurious%20dark%20red%20texture%20with%20golden%20highlights%2C%20smooth%20elegant%20color%20transition%2C%20modern%20artistic%20background%2C%20no%20objects%20pure%20abstract%2C%20soft%20dreamy%20motion%20blur%20effect%2C%20rich%20warm%20tones%2C%20professional%20cinematic%20look%2C%20high%20saturation%20dark%20palette%2C%20fine%20art%20photography%20style&width=1920&height=800&seq=cta-bg-home-01&orientation=landscape"
          alt="吃瓜网站入口引导"
          title="一站式直达最新大瓜现场 - 吃瓜网站线路一"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/35 to-black/50"></div>

      <div className="relative z-10 px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
          <div className="lg:max-w-lg">
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white font-heading leading-none mb-4">
              51吃瓜网站
            </h2>
            <p className="text-sm md:text-base text-white/60 font-body max-w-md leading-relaxed">
              聚合全网最热吃瓜入口，涵盖51吃瓜在线观看、黑料吃瓜、吃瓜网址等热门通道
            </p>
          </div>

          <div className="flex-shrink-0">
            <Link
              to="/category/51-chigua"
              className="inline-flex items-center gap-3 bg-white text-foreground-950 px-8 py-4 rounded-full text-base font-semibold whitespace-nowrap hover:bg-white/90 transition-all duration-200 hover:scale-105 cursor-pointer"
            >
              进入吃瓜入口
              <span className="w-7 h-7 flex items-center justify-center bg-foreground-950 text-white rounded-full">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}